// extracted by mini-css-extract-plugin
module.exports = {"item":"CheckedList_item__EWQKi","icon":"CheckedList_icon__0ATso"};